<template>
    <div
        class="bigdata_container"
        id="bigdata"
        v-loading="isLoading"
        element-loading-text="拼命加载中..."
        element-loading-background="rgba(0, 0, 0, 0.6)"
    >
        <div
            id="container"
            class="mymap"
            style="width: 100%; height: 100%"
        ></div>
        <!-- <img src="./assets/imgs/laian/map1.png" style="position:fixed;top:22%;left:12%;z-index:12;z-index:1;width:676px;height:849px;"> -->
        <div class="top-menu flex-item">
            <div class="flex-item l1">
                <div>
                    <p>
                        <img
                            src="./assets/big/oldIcon1.png"
                            alt=""
                            srcset=""
                        />{{ targetName ? targetName : "来安县" }}常住人口
                    </p>
                    <p class="nums">{{ changzhu }}</p>
                    <!-- <p class="nums">{{ peopleList.permanent }}</p> -->
                </div>

                <div>
                    <p>
                        <img
                            src="./assets/big/oldIcon2.png"
                            alt=""
                            srcset=""
                        />{{ targetName ? targetName : "来安县" }}家庭户
                    </p>
                    <p class="nums">{{ huji }}</p>
                    <!-- <p class="nums">{{ peopleList.householdRegistration }}</p> -->
                </div>
            </div>
            <div class="flex-item l2" style="width: 50%">
                <div>
                    <p class="nums color-l">68167</p>
                    <!-- {{ peopleList.totalCount || 0}} -->
                    <p>60岁以上(人)</p>
                </div>
                <div>
                    <p class="nums color-z">31504</p>
                    <!-- {{ peopleList.sixtyToEightyNine || 0}} -->
                    <p>70岁以上(人)</p>
                </div>
                <div>
                    <p class="nums color-h">10878</p>
                    <!-- {{ peopleList.ninetyToNinetyFour || 0}} -->
                    <p>80岁以上(人)</p>
                </div>
                <!-- <div>
            <p class="nums color-l"></p>
            <!-- {{ peopleList.ninetyFiveToninetyNine || 0}}
            <p>95-99岁以上(人)</p>
          </div> -->
                <div>
                    <p class="nums color-q">3063</p>
                    <p>85岁以上(人)</p>
                </div>
            </div>
            <div class="flex-item l3" style="width: 20%">
                <div @click="gethelpPeople(1)" class="shubaio">
                    <p class="nums color-z">2392</p>
                    <p>特困老人</p>
                </div>
                <div>
                    <p class="nums color-g">17542</p>
                    <p>低保老人</p>
                </div>
            </div>
        </div>
        <div class="oldRight">
            <div class="area">
                <!-- aactive -->
                <div
                    @click="changeArea(index, item)"
                    :class="{ aactive: activeIndex == index }"
                    v-for="(item, index) in listArea"
                    :key="index"
                >
                    {{ item }}
                </div>
            </div>
            <!-- 老年社区 -->
            <div class="oldBox">
                <div class="leftTitle">
                    {{ targetName ? targetName : "" }}老年人数量
                </div>
                <div id="oldNums"></div>
            </div>
            <!-- 人口比例数 -->
            <div class="oldBox">
                <div class="leftTitle">
                    {{ targetName ? targetName : "" }}人口比例数
                </div>
                <div class="percentBox">
                    <div class="percentItem">
                        <p class="percentTitle">年龄段分析</p>
                        <div id="agePercent"></div>
                        <div class="mallNote">
                            <ul>
                                <li>
                                    <span class="icon icon1"></span
                                    ><span class="name">60-64岁</span>
                                </li>
                                <li>
                                    <span class="icon icon3"></span
                                    ><span class="name">65-69岁</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span class="icon icon4"></span
                                    ><span class="name">70-79岁</span>
                                </li>
                                <li>
                                    <span class="icon icon5"></span
                                    ><span class="name">80岁以上</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="percentItem">
                        <p class="percentTitle">健康分析</p>
                        <div id="healthPercent"></div>
                        <div class="mallNote" style="margin-top: -70px">
                            <ul>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #f21b62"
                                    ></span
                                    ><span class="name">高血压</span>
                                </li>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #7fd42d"
                                    ></span
                                    ><span class="name">脑血管疾病</span>
                                </li>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #22f7ff"
                                    ></span
                                    ><span class="name">肾脏疾病</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #0f5bf5"
                                    ></span
                                    ><span class="name">糖尿病</span>
                                </li>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #d800ff"
                                    ></span
                                    ><span class="name">血管疾病</span>
                                </li>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #2372be"
                                    ></span
                                    ><span class="name">心脏病</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span
                                        class="icon"
                                        style="background: #ffb026"
                                    ></span
                                    ><span class="name">眼部疾病</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 百岁老人信息弹窗 -->
        <div class="perInfoBox" v-if="showInfoPer1">
            <div
                class="info-txt"
                style="background-color: rgba(10, 88, 160, 0.8)"
            >
                <div class="info-item">
                    <p
                        class="intitle"
                        style="margin-bottom: 15px; font-size: 20px"
                    >
                        人员信息
                    </p>
                    <div
                        style="
                            align-items: center;
                            height: 200px;
                            background-color: #162a5b;
                        "
                    >
                        <p style="font-size: 18px; padding: 10px">基本信息</p>
                        <div>
                            <div
                                style="
                                    width: 120px;
                                    height: 120px;
                                    margin-right: 20px;
                                    float: right;
                                "
                            >
                                <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                            </div>
                            <div>
                                <div style="padding: 10px; width: 500px">
                                    <label for="">姓名：</label
                                    >{{ peopleInfo.name }}
                                    <span style="margin-left: 20px">
                                        <label for="">姓别：</label
                                        >{{ peopleInfo.sex }}
                                    </span>
                                    <span style="margin-left: 20px"
                                        ><label for="">年龄：</label
                                        >{{ peopleInfo.age }}岁</span
                                    >
                                    <p>
                                        <label for="">联系方式：</label
                                        >{{ peopleInfo.phone }}
                                        <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                                    </p>
                                    <p>
                                        <label for="">所属类型：百岁老人</label>
                                        <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                                    </p>
                                    <p>
                                        <label for="">家庭地址：</label
                                        >{{ peopleInfo.censusRegister }}
                                    </p>
                                    <!-- <span style="margin-left:10px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span>
                    <span style="margin-left:10px"><label for="">家庭住址：</label>{{ peopleInfo.nation }}</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-item">
                    <p class="intitle">家庭成员信息</p>
                    <div style="background-color: #162a5b">
                        <p style="width: 100%; height: 169px" class="tableBox">
                            <el-table
                                :data="housePeopleList"
                                bgcolor="#01117b"
                                border
                                style="
                                    width: 100%;
                                    height: 100%;
                                    overflow-y: scroll;
                                "
                            >
                                <el-table-column
                                    type="index"
                                    width="70"
                                    label="序号"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="姓名"
                                    :show-overflow-tooltip="true"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="phone"
                                    label="电话"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="relationship"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="与老人关系"
                                >
                                </el-table-column>
                            </el-table>
                        </p>

                        <!-- <p style="width: 33%">
                <label for="">户籍：</label
                >{{ peopleInfo.lifeArea == 1 ? "城市户口" : "农村户口" }}
              </p>
              <p style="width: 33%"><label for="">保障：</label>XXXXXXXXXXX</p>
              <p style="width: 33%"><label for="">低保原因：</label>孤独老人</p> -->
                    </div>
                </div>
                <div class="info-item">
                    <!-- <p class="intitle">特困信息</p> -->
                    <div
                        style="
                            display: flex;
                            justify-content: space-around;
                            height: 220px;
                        "
                    >
                        <div style="width: 30%">
                            <p style="text-align: center">帮扶信息</p>
                            <div style="height: 223px; background: #162a5b">
                                {{ peopleInfo.assistanceProgram }}
                            </div>
                        </div>
                        <div style="width: 30%">
                            <p style="text-align: center">社区活动</p>
                            <div style="height: 223px; background: #162a5b">
                                <div class="activeList2">
                                    <div
                                        class="ac-title2"
                                        style="display: flex"
                                    >
                                        <div style="width: 50px">序号</div>
                                        <div style="flex: 1">活动类型</div>
                                        <div style="flex: 1">活动名称</div>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tableActive"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="ac-item"
                                                style="display: flex"
                                                v-for="(
                                                    item, index
                                                ) in tableActive"
                                                :key="index"
                                                @click="getactiveInfo(item)"
                                            >
                                                <div style="width: 50px">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        white-space: nowrap;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    <span v-if="item.type == 1"
                                                        >图文</span
                                                    >
                                                    <span v-if="item.type == 2"
                                                        >视频</span
                                                    >
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        :content="item.name"
                                                        placement="top"
                                                    >
                                                        <span>{{
                                                            item.name
                                                        }}</span>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 30%">
                            <p style="text-align: center">活动计划</p>
                            <div style="height: 223px; background: #162a5b">
                                <div class="activeList2">
                                    <div
                                        class="ac-title2"
                                        style="display: flex"
                                    >
                                        <div style="width: 50px">序号</div>
                                        <div style="flex: 1">活动名称</div>
                                        <div style="flex: 1">活动内容</div>
                                        <div style="flex: 1">活动时间</div>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tablePlan"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="ac-item"
                                                style="display: flex"
                                                v-for="(
                                                    item, index
                                                ) in tablePlan"
                                                :key="index"
                                            >
                                                <div style="width: 50px">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.name }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.content }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.activityTime }}
                                                </div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="info-item">
            <p class="intitle">两残补贴信息</p>
            <p style="width: 33%"><label for="">残疾等级：</label>孤独老人</p>
          </div>
          <div class="info-item">
            <p class="intitle">社区活动</p>
            <div>
              <iframe
                src="https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/E60167235/3.live&autoplay=1&audio=1&accessToken=at.91ryaacu4px3vufc64aqwf9ndpl3k7gk-67w5hvxb6i-0caeunm-8trebo2cf&templete=2"
                width="400"
                height="200"
                id="ysopen"
                allowfullscreen
              >
              </iframe>
            </div>
          </div> -->
                <span class="close-info" @click="showInfoPer1 = false">×</span>
            </div>
        </div>
        <!-- 特困老人 -->
        <div class="perInfoBox" v-if="showInfoPer2">
            <div
                class="info-txt"
                style="background-color: rgba(10, 88, 160, 0.8)"
            >
                <div class="info-item">
                    <p
                        class="intitle"
                        style="margin-bottom: 15px; font-size: 20px"
                    >
                        人员信息
                    </p>
                    <div
                        style="
                            align-items: center;
                            height: 200px;
                            background-color: #162a5b;
                        "
                    >
                        <p style="font-size: 18px; padding: 10px">基本信息</p>
                        <div>
                            <div
                                style="
                                    width: 120px;
                                    height: 120px;
                                    margin-right: 20px;
                                    float: right;
                                "
                            >
                                <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                            </div>
                            <div>
                                <div style="padding: 10px; width: 500px">
                                    <label for="">姓名：</label
                                    >{{ peopleInfo.name }}
                                    <span style="margin-left: 20px">
                                        <label for="">姓别：</label
                                        >{{ peopleInfo.sex == 1 ? "男" : "女" }}
                                    </span>
                                    <span style="margin-left: 20px"
                                        ><label for="">年龄：</label
                                        >{{ peopleInfo.age }}岁</span
                                    >
                                    <p>
                                        <label for="">联系方式：</label
                                        >{{ peopleInfo.phone }}
                                        <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                                    </p>
                                    <p>
                                        <label for="">所属类型：特困老人</label>
                                        <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                                    </p>
                                    <p>
                                        <label for="">家庭地址：</label
                                        >{{ peopleInfo.censusRegister }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <span class="close-info" @click="showInfoPer2 = false">×</span>
            </div>
        </div>
        <!-- 低保老人 -->
        <div class="perInfoBox" v-if="showInfoPer3">
            <div
                class="info-txt"
                style="background-color: rgba(10, 88, 160, 0.8)"
            >
                <div class="info-item">
                    <p
                        class="intitle"
                        style="margin-bottom: 15px; font-size: 20px"
                    >
                        人员信息
                    </p>
                    <div
                        style="
                            align-items: center;
                            height: 200px;
                            background-color: #162a5b;
                        "
                    >
                        <p style="font-size: 18px; padding: 10px">基本信息</p>
                        <div>
                            <div
                                style="
                                    width: 120px;
                                    height: 120px;
                                    margin-right: 20px;
                                    float: right;
                                "
                            >
                                <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                            </div>
                            <div>
                                <div style="padding: 10px; width: 500px">
                                    <label for="">姓名：</label
                                    >{{ peopleInfo.name }}
                                    <span style="margin-left: 20px">
                                        <label for="">姓别：</label
                                        >{{ peopleInfo.sex == 1 ? "男" : "女" }}
                                    </span>
                                    <span style="margin-left: 20px"
                                        ><label for="">年龄：</label
                                        >{{ peopleInfo.age }}岁</span
                                    >
                                    <p>
                                        <label for="">联系方式：</label
                                        >{{ peopleInfo.phone }}
                                        <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                                    </p>
                                    <p>
                                        <label for="">所属类型：低保老人</label>
                                        <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                                    </p>
                                    <p>
                                        <label for="">家庭地址：</label
                                        >{{ peopleInfo.censusRegister }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-item">
                    <p class="intitle">低保信息</p>
                    <div style="background-color: #162a5b">
                        <p style="width: 100%; height: 169px">
                            {{ peopleInfo.fidelityReason }}
                        </p>
                    </div>
                </div>
                <div class="info-item">
                    <div
                        style="
                            display: flex;
                            justify-content: space-around;
                            height: 220px;
                        "
                    >
                        <div style="width: 30%">
                            <p style="text-align: center">帮扶信息</p>
                            <div style="height: 190px; background: #162a5b">
                                {{ peopleInfo.assistanceProgram }}
                            </div>
                        </div>
                        <div style="width: 30%">
                            <p style="text-align: center">社区活动</p>
                            <div style="height: 190px; background: #162a5b">
                                <div class="activeList2">
                                    <div
                                        class="ac-title2"
                                        style="display: flex"
                                    >
                                        <div style="width: 50px">序号</div>
                                        <div style="flex: 1">活动类型</div>
                                        <div style="flex: 1">活动名称</div>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tableActive2"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="ac-item"
                                                style="display: flex"
                                                v-for="(
                                                    item, index
                                                ) in tableActive2"
                                                :key="index"
                                                @click="getactiveInfo(item)"
                                            >
                                                <div style="width: 50px">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        white-space: nowrap;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    <span v-if="item.type == 1"
                                                        >图文</span
                                                    >
                                                    <span v-if="item.type == 2"
                                                        >视频</span
                                                    >
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        :content="item.name"
                                                        placement="top"
                                                    >
                                                        <span>{{
                                                            item.name
                                                        }}</span>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 30%">
                            <p style="text-align: center">活动计划</p>
                            <div style="height: 190px; background: #162a5b">
                                <div class="activeList2">
                                    <div
                                        class="ac-title2"
                                        style="display: flex"
                                    >
                                        <div style="width: 50px">序号</div>
                                        <div style="flex: 1">活动名称</div>
                                        <div style="flex: 1">活动内容</div>
                                        <div style="flex: 1">活动时间</div>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tablePlan2"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="ac-item"
                                                style="display: flex"
                                                v-for="(
                                                    item, index
                                                ) in tablePlan2"
                                                :key="index"
                                            >
                                                <div style="width: 50px">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.name }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.content }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.activityTime }}
                                                </div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="close-info" @click="showInfoPer3 = false">×</span>
            </div>
        </div>
        <!-- 两残补贴 -->
        <div class="perInfoBox" v-if="showInfoPer4">
            <div
                class="info-txt"
                style="background-color: rgba(10, 88, 160, 0.8)"
            >
                <div class="info-item">
                    <p
                        class="intitle"
                        style="margin-bottom: 15px; font-size: 20px"
                    >
                        人员信息
                    </p>
                    <div
                        style="
                            align-items: center;
                            height: 200px;
                            background-color: #162a5b;
                        "
                    >
                        <p style="font-size: 18px; padding: 10px">基本信息</p>
                        <div>
                            <div
                                style="
                                    width: 120px;
                                    height: 120px;
                                    margin-right: 20px;
                                    float: right;
                                "
                            >
                                <!-- <img
                    style="width: 100%; height: 100%"
                    :src='peopleInfo.photoUrl'
                    alt=""
                  /> -->
                            </div>
                            <div>
                                <div style="padding: 10px; width: 500px">
                                    <label for="">姓名：</label
                                    >{{ peopleInfo.name }}
                                    <span style="margin-left: 20px">
                                        <label for="">姓别：</label
                                        >{{ peopleInfo.sex == 1 ? "男" : "女" }}
                                    </span>
                                    <span style="margin-left: 20px"
                                        ><label for="">年龄：</label
                                        >{{ peopleInfo.age }}岁</span
                                    >
                                    <p>
                                        <label for="">联系方式：</label
                                        >{{ peopleInfo.phone }}
                                        <!-- <span style="margin-left:20px"><label for="">所属社区：</label>{{ peopleInfo.communityName }}</span> -->
                                    </p>
                                    <p>
                                        <label for="">所属类型：两残</label>
                                        <!-- <span style="margin-left:20px"><label for="">健康分析：</label></span> -->
                                    </p>
                                    <p>
                                        <label for="">家庭地址：</label
                                        >{{ peopleInfo.censusRegister }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-item">
                    <p class="intitle">残疾类别和等级</p>
                    <div style="background-color: #162a5b">
                        <p
                            style="
                                width: 100%;
                                height: 169px;
                                padding: 0px 0 0 20px;
                            "
                        >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 1 ||
                                    peopleInfo.disabilityLevel == '多重一级'
                                "
                                >多重一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 2 ||
                                    peopleInfo.disabilityLevel == '多重二级'
                                "
                                >多重二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 3 ||
                                    peopleInfo.disabilityLevel == '精神一级'
                                "
                                >精神一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 4 ||
                                    peopleInfo.disabilityLevel == '精神二级'
                                "
                                >精神二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 5 ||
                                    peopleInfo.disabilityLevel == '精神三级'
                                "
                                >精神三级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 6 ||
                                    peopleInfo.disabilityLevel == '视力一级'
                                "
                                >视力一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 7 ||
                                    peopleInfo.disabilityLevel == '视力二级'
                                "
                                >视力二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 8 ||
                                    peopleInfo.disabilityLevel == '视力三级'
                                "
                                >视力三级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 9 ||
                                    peopleInfo.disabilityLevel == '视力四级'
                                "
                                >视力四级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 10 ||
                                    peopleInfo.disabilityLevel == '听力一级'
                                "
                                >听力一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 11 ||
                                    peopleInfo.disabilityLevel == '听力二级'
                                "
                                >听力二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 12 ||
                                    peopleInfo.disabilityLevel == '听力三级'
                                "
                                >听力三级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 13 ||
                                    peopleInfo.disabilityLevel == '听力四级'
                                "
                                >听力四级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 14 ||
                                    peopleInfo.disabilityLevel == '言语一级'
                                "
                                >言语一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 15 ||
                                    peopleInfo.disabilityLevel == '言语二级'
                                "
                                >言语二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 16 ||
                                    peopleInfo.disabilityLevel == '肢体一级'
                                "
                                >肢体一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 17 ||
                                    peopleInfo.disabilityLevel == '肢体二级'
                                "
                                >肢体二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 18 ||
                                    peopleInfo.disabilityLevel == '肢体三级'
                                "
                                >肢体三级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 19 ||
                                    peopleInfo.disabilityLevel == '肢体四级'
                                "
                                >肢体四级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 20 ||
                                    peopleInfo.disabilityLevel == '智力一级'
                                "
                                >智力一级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 21 ||
                                    peopleInfo.disabilityLevel == '智力二级'
                                "
                                >智力二级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 22 ||
                                    peopleInfo.disabilityLevel == '智力三级'
                                "
                                >智力三级</span
                            >
                            <span
                                v-if="
                                    peopleInfo.disabilityLevel == 23 ||
                                    peopleInfo.disabilityLevel == '智力四级'
                                "
                                >智力四级</span
                            >
                            <!-- <el-select v-model="peopleInfo.disabilityLevel"  placeholder="请选择">
                    <el-option
                    disabled
                    v-for="item in canjiList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select> -->
                        </p>
                    </div>
                </div>
                <div class="info-item">
                    <div
                        style="
                            display: flex;
                            justify-content: space-around;
                            height: 220px;
                        "
                    >
                        <div style="width: 30%">
                            <p style="text-align: center">帮扶信息</p>
                            <div style="height: 190px; background: #162a5b">
                                {{ peopleInfo.assistanceProgram }}
                            </div>
                        </div>
                        <div style="width: 30%">
                            <p style="text-align: center">社区活动</p>
                            <div style="height: 190px; background: #162a5b">
                                <div class="activeList2">
                                    <div
                                        class="ac-title2"
                                        style="display: flex"
                                    >
                                        <div style="width: 50px">序号</div>
                                        <div style="flex: 1">活动类型</div>
                                        <div style="flex: 1">活动名称</div>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tableActive3"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="ac-item"
                                                style="display: flex"
                                                v-for="(
                                                    item, index
                                                ) in tableActive3"
                                                :key="index"
                                                @click="getactiveInfo(item)"
                                            >
                                                <div style="width: 50px">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        white-space: nowrap;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    <span v-if="item.type == 1"
                                                        >图文</span
                                                    >
                                                    <span v-if="item.type == 2"
                                                        >视频</span
                                                    >
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        :content="item.name"
                                                        placement="top"
                                                    >
                                                        <span>{{
                                                            item.name
                                                        }}</span>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 30%">
                            <p style="text-align: center">活动计划</p>
                            <div style="height: 190px; background: #162a5b">
                                <div class="activeList2">
                                    <div
                                        class="ac-title2"
                                        style="display: flex"
                                    >
                                        <div style="width: 50px">序号</div>
                                        <div style="flex: 1">活动名称</div>
                                        <div style="flex: 1">活动内容</div>
                                        <div style="flex: 1">活动时间</div>
                                    </div>
                                    <div
                                        class="houseContent"
                                        style="height: 620px; overflow: scroll"
                                    >
                                        <vue-seamless-scroll
                                            :style="{
                                                height:
                                                    this.scrollHeight + 'px',
                                            }"
                                            :data="tablePlan3"
                                            :class-option="defaultOption"
                                            class="warp-content"
                                        >
                                            <div
                                                class="ac-item"
                                                style="display: flex"
                                                v-for="(
                                                    item, index
                                                ) in tablePlan3"
                                                :key="index"
                                            >
                                                <div style="width: 50px">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.name }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.content }}
                                                </div>
                                                <div
                                                    style="
                                                        flex: 1;
                                                        width: 160px;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    "
                                                >
                                                    {{ item.activityTime }}
                                                </div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="close-info" @click="showInfoPer4 = false">×</span>
            </div>
        </div>
    </div>
</template>

<script>
// import baseURL from "@/api/baseURL"
import request from "@/utils/request.js"

export default {
    name: "visualized",
    data() {
        return {
            isLoading: false,
            targetName: "",
            peopleList: {
                age1: "0",
                age2: "0",
                age3: "0",
                age4: "0",
                age5: "0",
                tkType: "0",
                dbType: "0",
                lcbtType: "0",
            },
            listArea: [],
            changzhu: "432021",
            huji: "138180",
            showInfoPer1: false, //人员信息弹窗
            showInfoPer2: false,
            showInfoPer3: false,
            showInfoPer4: false,
            peopleInfo: {},
            peopleLists: [],
            areaList: [],
            markers: [],
            markerss: [],
            image: "",
            communityList: [
                {
                    id: 140,
                    longitude: 118.434581,
                    latitude: 32.428848,
                    name: "新安镇",
                    // address: "江苏省南京市浦口区江浦街道",
                },
                {
                    id: 141,
                    longitude: 118.588275,
                    latitude: 32.675221,
                    name: "半塔镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 142,
                    longitude: 118.595726,
                    latitude: 32.206585,
                    name: "汊河镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 143,
                    longitude: 118.497759,
                    latitude: 32.317896,
                    name: "水口镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 144,
                    longitude: 118.441856,
                    latitude: 32.536382,
                    name: "舜山镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 145,
                    longitude: 118.620944,
                    latitude: 32.345538,
                    name: "雷官镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 146,
                    longitude: 118.580735,
                    latitude: 32.455542,
                    name: "施官镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 147,
                    longitude: 118.59775,
                    latitude: 32.295551,
                    name: "大英镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 148,
                    longitude: 118.498851,
                    latitude: 32.496037,
                    name: "张山镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 149,
                    longitude: 118.651457,
                    latitude: 32.403991,
                    name: "独山镇",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 150,
                    longitude: 118.450073,
                    latitude: 32.25309,
                    name: "三城乡",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 151,
                    longitude: 118.651457,
                    latitude: 32.403991,
                    name: "独山乡",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 152,
                    longitude: 118.498851,
                    latitude: 32.4960371,
                    name: "张山乡",
                    // address: "南京市浦口区白马路8号",
                },
                {
                    id: 153,
                    longitude: 118.46178,
                    latitude: 32.644449,
                    name: "杨郢乡",
                    // address: "南京市浦口区白马路8号",
                },
            ],
        }
    },
    created() {
        this.$nextTick(() => {
            this.loadMap().then(() => {
                this.getDistrict()
                this.showditu()
               // this.gethelpPeople(1)
            })
        })
        // this.getHealth()
        // this.getAgePercent()
        // this.oldNums()
        // this.showditu()
    },
    mounted() {
        this.getolder()
        // this.loadMap()
        this.showditu()
        this.getHealth()
        this.oldNums()
        this.getAgePercent()
    },
    methods: {
        //统计年龄段老人数
        getolder() {
            this.$http
                .request({
                    url: "ypt/admin/laian/customer/info/findAgeCount",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.peopleList = res.content
                        }
                        console.log(res.content)
                    }
                })
        },
        //老人打点
        getoldPeople(val) {
            this.$http
                .request({
                    url: "ypt/admin/laian/customer/info/findList",
                    method: "POST",
                    data: {
                        ageFlag: val,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.map.remove(this.markerss)
                            this.markerss = []
                            this.peopleLists = []
                            res.content.list.forEach((item) => {
                                if (
                                    item.id &&
                                    item.longitude &&
                                    item.latitude
                                ) {
                                    this.peopleLists.push({
                                        id: item.id,
                                        name: item.customerName,
                                        age: item.age,
                                        longitude: item.longitude,
                                        latitude: item.latitude,
                                        phone: item.familyPhone,
                                        sex: item.gender,
                                        censusRegister: item.address,
                                    })
                                }
                            })
                            console.log(this.peopleLists)
                            this.image = require("./assets/big/nine.png")
                            this.renderMapMarkers(this.peopleLists, 1)
                        }
                    }
                })
        },
        //健康分析
        async getHealth() {
            const myChart = this.$echarts.init(
                document.getElementById("healthPercent")
            )
            var option
            option = {
                tooltip: {
                    trigger: "item",
                    // formatter: function (params) {
                    //   return `${params.data.name}<br/>人数：${params.data.value}`;
                    // },
                },
                color: [
                    "#F21B62",
                    "#7FD42D",
                    "#22F7FF",
                    "#0F5BF5",
                    "#D800FF",
                    "#2372BE",
                    "#FFB026",
                ],
                // color: ["#F21B62", "#0F5BF5", "#2372BE", "#FFB026"],
                calculable: true,
                series: [
                    {
                        name: "访问来源",
                        type: "pie",
                        radius: "50%",
                        center: ["50%", "30%"],
                        label: {
                            normal: {
                                position: "inner",
                                show: true,
                                textStyle: {
                                    fontSize: 12, //文字的字体大小
                                },
                                formatter: "{c}",
                            },
                        },
                        data: [
                            { value: 1749, name: "高血压" },
                            { value: 417, name: "脑血管疾病" },
                            { value: 10, name: "肾脏疾病" },
                            { value: 744, name: "糖尿病" },
                            { value: 34, name: "血管疾病" },
                            { value: 2, name: "心脏病" },
                            { value: 1, name: "眼部疾病" },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 年龄百分比
        async getAgePercent() {
            const myChart = this.$echarts.init(
                document.getElementById("agePercent")
            )
            var option
            option = {
                tooltip: {
                    trigger: "item",
                },
                color: ["#0F5BF5", "#7FD42D", "#F21B62", "#FFB026"],
                series: [
                    {
                        name: "年龄段",
                        type: "pie",
                        radius: [30, 40],
                        center: ["35%", "30%"],
                        data: [
                            { value: 20554, name: "60-64岁" },
                            {
                                value: 20554,
                                name: "65-69岁",
                            },
                            {
                                value: 20626,
                                name: "70-79岁",
                            },
                            {
                                value: 8822,
                                name: "80岁以上",
                            },
                        ],
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        // 老年人口数量
        async oldNums() {
            const myChart = this.$echarts.init(
                document.getElementById("oldNums")
            )
            var option
            option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                color: ["#0F5BF5", "#F21B62"],
                legend: {
                    icon: "circle",
                    data: ["男", "女"],
                    right: "0",
                    top: "20",
                    textStyle: {
                        fontSize: 12,
                        color: "#fff",
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        data: [
                            "新安镇",
                            "半塔镇",
                            "水口镇",
                            "汊河镇",
                            "大英镇",
                            "雷官镇",
                            "施官镇",
                            "舜山镇",
                            "三城乡",
                            "独山乡",
                            "张山乡",
                            "杨郢乡",
                        ],
                        axisLabel: {
                            interval: 0,
                            rotate: 65,
                        },
                        axisLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#fff", //左边线的颜色
                                width: "1", //坐标线的宽度
                            },
                        },
                        axisTick: {
                            alignWithLabel: true,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#fff", //左边线的颜色
                                width: "1", //坐标线的宽度
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "男",
                        type: "bar",
                        stack: "人数",
                        emphasis: {
                            focus: "series",
                        },
                        barWidth: 20,
                        // data: mData,
                        data: [
                            51696, 33153, 25131, 18293, 8102, 11597, 17275,
                            13617, 9339, 9356, 10045, 8417,
                        ],
                        barGap: "0",
                        label: {
                            normal: {
                                show: true,
                                formatter: "{c}",
                                align: "center",
                                verticalAlign: "middle",
                                rotate: 90,
                                position: "top",
                                distance: -24,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                    {
                        name: "女",
                        type: "bar",
                        stack: "人数",
                        emphasis: {
                            focus: "series",
                        },
                        // data: fData,
                        data: [
                            53932, 33561, 25041, 17481, 7808, 11324, 16882,
                            13059, 9050, 9332, 10348, 8182,
                        ],
                        barGap: "0",
                        barWidth: 20,
                        label: {
                            normal: {
                                show: true,
                                formatter: "{c}",
                                align: "center",
                                verticalAlign: "middle",
                                rotate: 90,
                                position: "top",
                                distance: -24,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                    {
                        //新的一个柱子 注意不设stack
                        name: "总数",
                        type: "bar",
                        barGap: "0%", // 左移100%，stack不再与上面两个在一列
                        barWidth: 9,
                        label: {
                            normal: {
                                show: true,
                                barWidth: 0,
                                formatter: "{c}",
                                align: "center",
                                verticalAlign: "middle",
                                rotate: 90,
                                position: "top",
                                color: "rgba(128, 128, 128, 0)",
                                background: "rgba(128, 128, 128, 0),",
                                distance: 25,
                                left: "-30",
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                        data: [
                            105628, 66714, 50172, 35774, 15910, 22921, 34157,
                            26676, 18389, 18688, 20393, 16599,
                        ],
                        // data: this.targetId ? allnumber : totalData,
                    },
                ],
            }
            option && myChart.setOption(option)
        },
        async showditu() {
            this.map.remove(this.markers)
            this.markers = []
            this.image = require("./assets/big/f1.png")
            //  this.renderMapMarker(this.communityList)
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 6,
                    center: [118.84315, 32.458977],
                    //   zoomEnable:false,
                    //  dragEnable: false,
                })
                this.setArea()
                resolve()
            })
        },
        getDistrict(name = "341122", params = null) {
            let self = this
            // return new Promise((resolve, reject) => {
            var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
            }
            let district = new AMap.DistrictSearch(opts)

            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }

            self.marker = new AMap.Marker()
            district.search(name, (status, result) => {
                if (status == "complete") {
                    let areaList = []
                    result.districtList[0].districtList.forEach((item) => {
                        console.log(item, "下次code")
                        areaList.push({
                            adcode: item.adcode,
                            name: item.name,
                        })
                    })
                    // areaList[0].color = "#24609C"
                    // areaList[1].color = "#467399"
                    // areaList[2].color = "#0C2FA0"
                    // areaList[3].color = "#3769A6"
                    // areaList[4].color = "#22598D"
                    // areaList[5].color = "#326A9D"
                    // areaList[6].color = "#0C2FA0"
                    // areaList[7].color = "#2568A2"
                    // areaList[8].color = "#134CA2"
                    // areaList[9].color = "#183B77"
                    // areaList[10].color = "#183B70"
                    // areaList[11].color = "#183B70"

                    self.areaList = areaList
                    self.map.setZoom(10.5)
                    self.map.setCenter([118.84315, 32.458977])
                    self.drawArea()
                }
            })
        },
        setArea() {
            let arr = [
                {
                    pointPosition:
                        "118.50145:32.721362,118.49939:32.711732,118.519561:32.676916,118.535611:32.676555,118.538529:32.67576,118.538357:32.672003,118.532349:32.668679,118.526513:32.663477,118.51175:32.654806,118.50557:32.651626,118.49733:32.645845,118.495614:32.641219,118.492524:32.634281,118.493897:32.626185,118.494927:32.607677,118.511407:32.58743,118.512093:32.579909,118.512093:32.572966,118.51278:32.567179,118.521706:32.560235,118.531319:32.558498,118.542306:32.561392,118.549859:32.55792,118.551919:32.558498,118.556768:32.560343,118.569557:32.586273,118.574878:32.588334,118.577968:32.593613,118.592045:32.598965,118.599769:32.603809,118.608953:32.597518,118.621828:32.594915,118.624918:32.591733,118.628694:32.590287,118.632428:32.580054,118.638221:32.581645,118.643071:32.588696,118.650452:32.592818,118.65307:32.598748,118.654958:32.599001,118.658306:32.598458,118.664056:32.596,118.679451:32.596589,118.689086:32.589719,118.701553:32.589701,118.703218:32.600432,118.699115:32.602867,118.70092:32.606048,118.700775:32.613264,118.696054:32.616951,118.695679:32.618515,118.702202:32.621723,118.704133:32.627135,118.685368:32.634318,118.675412:32.6314,118.673749:32.63327,118.671539:32.635692,118.666003:32.637833,118.665573:32.641506,118.674414:32.64895,118.682482:32.649167,118.687289:32.652563,118.693726:32.650973,118.695357:32.651985,118.693125:32.660368,118.698618:32.666437,118.699562:32.673662,118.694842:32.692734,118.697846:32.69779,118.700764:32.700318,118.712008:32.703568,118.716299:32.715196,118.713553:32.718445,118.706429:32.716712,118.69982:32.721695,118.695958:32.721767,118.689434:32.728699,118.679135:32.728554,118.657505:32.735414,118.652356:32.741406,118.647377:32.742128,118.640339:32.744077,118.633473:32.739023,118.628237:32.742056,118.619053:32.740467,118.60738:32.728266,118.591502:32.723211,118.583948:32.722995,118.571846:32.718301,118.569701:32.719601,118.564894:32.729277,118.559272:32.729854,118.538287:32.727435,118.535626:32.727652,118.530905:32.726208,118.529188:32.725847,118.526184:32.726858,118.520434:32.723536,118.51228:32.725341",
                    gridColour: "1565C0",
                    orgName: "半塔镇",
                },
                {
                    pointPosition:
                        "118.402236:32.551454,118.420221:32.55816,118.422324:32.559715,118.428418:32.567257,118.413273:32.586431,118.406117:32.595628,118.39954:32.595749,118.395614:32.596797,118.39158:32.595496,118.376162:32.597295,118.370851:32.592965,118.365133:32.582063,118.35685:32.573384,118.353374:32.566368,118.34492:32.564342,118.34286:32.560798,118.342216:32.557434,118.346851:32.552514,118.347881:32.547052,118.351872:32.540685,118.336337:32.515501,118.336895:32.498491,118.33874:32.49708,118.34286:32.500627,118.347581:32.495632,118.354576:32.477604,118.351743:32.475251,118.342259:32.476953,118.341959:32.476989,118.342989:32.483035,118.339126:32.484374,118.333461:32.482383,118.328355:32.474817,118.331702:32.462398,118.331444:32.461963,118.324235:32.460985,118.319385:32.455807,118.31887:32.448275,118.330801:32.440887,118.332689:32.443965,118.336766:32.445667,118.336895:32.445559,118.337324:32.442842,118.340113:32.44277,118.345778:32.436576,118.344748:32.429912,118.352516:32.42926,118.354962:32.41861,118.354962:32.418139,118.348954:32.413139,118.348793:32.412994,118.350284:32.412188,118.350201:32.412233,118.350169:32.411799,118.350582:32.412199,118.3511:32.412358,118.352425:32.412415,118.353178:32.412034,118.355851:32.411244,118.359348:32.411389,118.365678:32.412648,118.38072:32.414577,118.389496:32.412711,118.400826:32.399414,118.445072:32.398436,118.471636:32.40224,118.473053:32.43307,118.476143:32.444515,118.473053:32.483403,118.472945:32.483874,118.455853:32.481793,118.409418:32.486064,118.401865:32.490046,118.402209:32.497358,118.400921:32.506985,118.392767:32.511039,118.388132:32.514296,118.383583:32.52204,118.385386:32.531954,118.401608:32.550712,118.401608:32.550712,118.40197:32.551144",
                    gridColour: "1565C0",
                    orgName: "新安镇",
                },
                {
                    pointPosition:
                        "118.480365:32.259,118.484753:32.255661,118.494623:32.247724,118.531444:32.229575,118.539555:32.226997,118.55007:32.221697,118.558309:32.216904,118.568051:32.218139,118.58335:32.201572,118.585807:32.20051,118.588833:32.200301,118.590308:32.200637,118.59217:32.200206,118.592336:32.200097,118.592363:32.195319,118.594742:32.194706,118.597035:32.199759,118.610564:32.202383,118.619147:32.205869,118.62758:32.202709,118.629747:32.203345,118.636721:32.207757,118.644274:32.210335,118.649832:32.217724,118.666225:32.23368,118.671976:32.245132,118.67586:32.254641,118.673907:32.25622,118.66998:32.256456,118.660645:32.261555,118.649187:32.259704,118.647921:32.259976,118.646188:32.261323,118.644954:32.262153,118.642937:32.263242,118.641693:32.262879,118.640019:32.265057,118.596031:32.278287,118.584358:32.274223,118.567192:32.27045,118.548309:32.271611,118.534919:32.273062,118.514663:32.272482,118.505737:32.272772,118.502304:32.273353,118.497154:32.274223,118.493034:32.274804,118.483764:32.275385,118.483421:32.275385,118.481361:32.273788,118.480503:32.272191,118.481704:32.269288,118.484107:32.268272,118.482906:32.264208,118.481532:32.262031,118.480846:32.260126",
                    gridColour: "FC466B",
                    orgName: "汉河镇",
                },
                {
                    pointPosition:
                        "118.406144:32.595644,118.413407:32.586327,118.413517:32.586485,118.420558:32.577698,118.428283:32.566704,118.466391:32.571912,118.473601:32.577409,118.480468:32.580302,118.487334:32.578277,118.490424:32.57249,118.493514:32.566704,118.49832:32.558313,118.512397:32.567246,118.511753:32.573033,118.511753:32.579868,118.511195:32.587389,118.49472:32.607773,118.493733:32.62628,118.492317:32.634376,118.495643:32.641351,118.497295:32.64603,118.505471:32.651631,118.52651:32.663496,118.532314:32.668698,118.538349:32.672006,118.538523:32.675756,118.535609:32.676553,118.519553:32.676912,118.499377:32.711737,118.5014:32.721356,118.490725:32.723875,118.490124:32.722972,118.489974:32.722728,118.487098:32.721501,118.483901:32.720427,118.480135:32.722404,118.479588:32.722485,118.474878:32.721059,118.469599:32.721275,118.466531:32.722458,118.464943:32.723595,118.461403:32.724064,118.458774:32.725328,118.456843:32.72948,118.454536:32.732566,118.451039:32.743883,118.448528:32.745616,118.441232:32.739606,118.431813:32.716735,118.427693:32.711806,118.418423:32.707184,118.414732:32.70072,118.419904:32.696079,118.421277:32.683908,118.428358:32.677406,118.434023:32.664148,118.431298:32.660065,118.42662:32.657229,118.420097:32.659595,118.415762:32.656181,118.414303:32.650508,118.415548:32.640318,118.419195:32.636469,118.427392:32.635078,118.427328:32.625807,118.417457:32.615452,118.413509:32.61462,118.409475:32.612704,118.408896:32.609686,118.41014:32.606053,118.410097:32.606053",
                    gridColour: "3F5EFB",
                    orgName: "杨郢乡",
                },
                {
                    pointPosition:
                        "118.402258:32.551458,118.419606:32.558199,118.422525:32.559863,118.424112:32.561346,118.428265:32.566681,118.466438:32.571904,118.473642:32.57741,118.480466:32.58024,118.487332:32.578224,118.498293:32.558294,118.496244:32.545145,118.493884:32.536969,118.496931:32.528756,118.49796:32.522351,118.494613:32.513196,118.488734:32.504727,118.490279:32.487208,118.486845:32.487244,118.474829:32.493362,118.472769:32.483869,118.456375:32.481862,118.442213:32.482224,118.42685:32.484722,118.410113:32.48617,118.402302:32.490152,118.402216:32.497536,118.4008:32.507381,118.39359:32.510747,118.387968:32.514221,118.383634:32.522037,118.385737:32.532349,118.392013:32.539558",
                    gridColour: "59C173",
                    orgName: "舜山镇",
                },
                {
                    pointPosition:
                        "118.577353:32.550531,118.572665:32.543043,118.574682:32.536205,118.576012:32.535373,118.579102:32.534866,118.580003:32.53407,118.58202:32.530597,118.582192:32.524699,118.575326:32.51985,118.556646:32.520256,118.5545:32.520921,118.551453:32.518605,118.545745:32.515239,118.539566:32.51466,118.533558:32.513285,118.529695:32.510462,118.527292:32.497143,118.529953:32.49584,118.551153:32.492872,118.539566:32.467168,118.538622:32.464054,118.539394:32.461809,118.557513:32.449868,118.558307:32.447967,118.55438:32.442806,118.540948:32.441205,118.52052:32.440119,118.511079:32.439612,118.504813:32.425423,118.506186:32.412961,118.5376:32.403831,118.483355:32.379044,118.478377:32.379044,118.473227:32.379479,118.472712:32.380059,118.471339:32.379479,118.453143:32.378754,118.444388:32.37252,118.438037:32.364872,118.43279:32.352714,118.430269:32.354019,118.427206:32.360742,118.414867:32.366989,118.411047:32.371665,118.40609:32.370976,118.402679:32.367352,118.399975:32.367714,118.389611:32.372897,118.391778:32.377084,118.384654:32.385751,118.382026:32.381407,118.376683:32.387378,118.372531:32.390096,118.368958:32.390449,118.366919:32.39333,118.371533:32.394055,118.375095:32.402352,118.376597:32.404273,118.37694:32.407606,118.372048:32.410903,118.36222:32.406882,118.35647:32.406555,118.35029:32.408838,118.349971:32.408931,118.350185:32.411748,118.350182:32.411795,118.350561:32.412176,118.350756:32.412232,118.350866:32.412269,118.351121:32.412371,118.35243:32.412414,118.353203:32.412024,118.355778:32.411254,118.359372:32.41139,118.364704:32.4125,118.365798:32.412681,118.380647:32.41451,118.38938:32.412717,118.400753:32.399402,118.444998:32.398568,118.471606:32.402264,118.473108:32.432442,118.47637:32.44577,118.47225:32.483862,118.474825:32.493237,118.486841:32.487265,118.490317:32.487301,118.488772:32.504783,118.494652:32.51318,118.498085:32.522444,118.497012:32.52874,118.493922:32.537061,118.496282:32.545129,118.498428:32.558369,118.512581:32.56722,118.521679:32.560203,118.531743:32.558394,118.531306:32.558473,118.542304:32.561365,118.549868:32.557892,118.55196:32.558471,118.556842:32.560343,118.558644:32.555415,118.56315:32.551978,118.575252:32.550739",
                    gridColour: "19D313",
                    orgName: "张山镇",
                },
                {
                    pointPosition:
                        "118.610594:32.472291,118.607447:32.439745,118.624785:32.435108,118.628733:32.425836,118.629591:32.41888,118.62736:32.413374,118.618433:32.409171,118.611395:32.402214,118.608477:32.394242,118.607619:32.391923,118.590109:32.389024,118.587191:32.391488,118.579123:32.389604,118.578951:32.399895,118.563845:32.39946,118.552:32.405548,118.545649:32.405982,118.53764:32.403854,118.506239:32.412918,118.504716:32.425471,118.51111:32.439488,118.540937:32.441118,118.554283:32.442712,118.558274:32.447818,118.557459:32.450136,118.539477:32.461833,118.538619:32.464223,118.539649:32.467336,118.55124:32.492887,118.529825:32.495999,118.527465:32.497158,118.529782:32.510368,118.533259:32.513191,118.539868:32.514675,118.545661:32.515218,118.551455:32.518474,118.554545:32.520899,118.556862:32.52032,118.575487:32.51985,118.582311:32.524662,118.582053:32.530958,118.580079:32.534251,118.57935:32.534938,118.575992:32.535454,118.574715:32.536195,118.572685:32.543045,118.577384:32.550558,118.609312:32.535044,118.608915:32.53219,118.605391:32.531032,118.605242:32.531009,118.602519:32.530188,118.603545:32.521139,118.606463:32.518189,118.617063:32.516597,118.618179:32.515566,118.616785:32.50831,118.616779:32.508132,118.610374:32.507114,118.608883:32.502065,118.592249:32.502157,118.593333:32.496239,118.591595:32.484366,118.594298:32.47785,118.59786:32.476329,118.605199:32.47756",
                    gridColour: "133DD3",
                    orgName: "施官镇",
                },

                {
                    pointPosition:
                        "118.607646:32.391909,118.608898:32.385628,118.609992:32.384378,118.611473:32.383308,118.613103:32.383109,118.616515:32.387857,118.627591:32.396598,118.628879:32.397178,118.630338:32.396308,118.636432:32.38935,118.648169:32.372643,118.648599:32.372534,118.670802:32.380435,118.667197:32.388263,118.6693:32.390039,118.671446:32.39022,118.680276:32.388462,118.677744:32.393862,118.685271:32.404388,118.688619:32.418953,118.685958:32.429241,118.689477:32.45032,118.691515:32.452619,118.690872:32.455824,118.68585:32.454339,118.683619:32.458975,118.685486:32.460061,118.690721:32.459319,118.69176:32.465047,118.690772:32.472269,118.685751:32.472957,118.673435:32.4693,118.649831:32.47665,118.64245:32.470061,118.631721:32.470712,118.63009:32.468685,118.627215:32.467852,118.619404:32.472305,118.610599:32.472299,118.607468:32.439799,118.624903:32.435109,118.628808:32.425582,118.629666:32.418808,118.627392:32.413374,118.618294:32.409099,118.611384:32.402106,118.611384:32.402106,118.611384:32.402106,118.607653:32.391981",
                    gridColour: "171E98",
                    orgName: "独山镇",
                },
                {
                    pointPosition:
                        "118.608894:32.385623,118.609332:32.378157,118.591737:32.337483,118.571653:32.336033,118.566159:32.333422,118.560666:32.327765,118.597573:32.31616,118.619031:32.317611,118.635167:32.303175,118.639545:32.299693,118.642463:32.29933,118.648814:32.296791,118.657092:32.299598,118.65714:32.301934,118.659586:32.305272,118.670744:32.309932,118.674692:32.314158,118.676559:32.315826,118.686794:32.318347,118.69497:32.317404,118.697266:32.318165,118.696386:32.320777,118.694004:32.321973,118.68894:32.321955,118.684134:32.323751,118.682975:32.326543,118.684134:32.327703,118.687846:32.330369,118.697116:32.329063,118.703446:32.329607,118.706857:32.332291,118.707716:32.338292,118.704905:32.339996,118.697395:32.341936,118.695957:32.346015,118.699583:32.349513,118.694047:32.349731,118.692184:32.352554,118.69536:32.357086,118.699308:32.357231,118.702012:32.357956,118.701969:32.358209,118.69978:32.359949,118.695961:32.360819,118.696304:32.364843,118.695704:32.367852,118.697592:32.36941,118.700596:32.368078,118.702312:32.36777,118.703697:32.368223,118.703396:32.371948,118.702109:32.373062,118.697731:32.373325,118.696809:32.375327,118.700692:32.376687,118.701787:32.377937,118.701572:32.379595,118.698514:32.383328,118.696133:32.383808,118.694019:32.382513,118.693729:32.380175,118.692345:32.377692,118.690747:32.377384,118.688215:32.38437,118.680254:32.38842,118.671424:32.390214,118.669235:32.390014,118.667218:32.388257,118.670856:32.380402,118.648668:32.372518,118.648089:32.372663,118.636395:32.389371,118.630279:32.396383,118.628841:32.397144,118.627618:32.3966,118.616503:32.387831,118.612984:32.383029,118.611353:32.383337,118.609916:32.384388",
                    gridColour: "EE1919",
                    orgName: "雷官镇",
                },
                {
                    pointPosition:
                        "118.573571:32.323689,118.55366:32.30881,118.552072:32.307632,118.550978:32.305709,118.55042:32.304367,118.559715:32.298275,118.567011:32.293922,118.573759:32.271899,118.584359:32.274222,118.596107:32.27844,118.640095:32.265041,118.641705:32.262909,118.642928:32.263254,118.644999:32.262165,118.646265:32.261312,118.64738:32.260441,118.647895:32.259988,118.649236:32.259716,118.66095:32.261614,118.658892:32.26583,118.663365:32.274396,118.670446:32.285172,118.669802:32.292755,118.66697:32.295983,118.660404:32.295693,118.657067:32.299593,118.648805:32.296768,118.642443:32.299316,118.639514:32.299679,118.619029:32.317599,118.59754:32.316142",
                    gridColour: "2EE919",
                    orgName: "大英镇",
                },
                {
                    pointPosition:
                        "118.421426:32.265965,118.424526:32.264885,118.425825:32.263706,118.441392:32.265602,118.450276:32.266999,118.455254:32.268251,118.462732:32.267852,118.480358:32.259023,118.481511:32.262017,118.482895:32.264221,118.484097:32.268267,118.481683:32.269283,118.480503:32.272186,118.481372:32.27381,118.483399:32.275361,118.493141:32.274808,118.497347:32.274209,118.504761:32.27293,118.505876:32.272749,118.514019:32.272486,118.515232:32.272458,118.534994:32.273066,118.549175:32.27156,118.5675:32.270399,118.57376:32.271897,118.567029:32.293912,118.564733:32.295227,118.55042:32.304405,118.552137:32.307724,118.573562:32.323697,118.560658:32.327764,118.566312:32.333593,118.571763:32.336131,118.591761:32.337509,118.609324:32.378165,118.608898:32.38564,118.607637:32.391919,118.590095:32.388954,118.58722:32.391454,118.579109:32.389606,118.578809:32.399861,118.563788:32.39939,118.551815:32.405586,118.545464:32.406021,118.53761:32.403847,118.483365:32.378987,118.473151:32.379386,118.472711:32.38002,118.471263:32.379431,118.45293:32.378645,118.444003:32.372193,118.437566:32.364255,118.43291:32.352745,118.436772:32.35057,118.435506:32.345404,118.43851:32.342177,118.437158:32.34031,118.421108:32.338297,118.419262:32.337318,118.419198:32.3342,118.424992:32.324935,118.431129:32.319749,118.43115:32.317699,118.42821:32.311606,118.434497:32.308215,118.428918:32.296154,118.429187:32.275365,118.423099:32.268019",
                    gridColour: "DFC925",
                    orgName: "水口镇",
                },
                {
                    pointPosition:
                        "118.421418:32.265923,118.419299:32.263414,118.415383:32.264031,118.408817:32.269461,118.40268:32.26996,118.397186:32.268799,118.396006:32.264761,118.395899:32.260552,118.397369:32.258855,118.399257:32.258737,118.400115:32.260461,118.401982:32.261867,118.404375:32.261269,118.405694:32.257785,118.404858:32.253538,118.40636:32.252949,118.411456:32.252386,118.415533:32.247459,118.416863:32.247214,118.419835:32.248403,118.42256:32.248612,118.423719:32.245926,118.423408:32.243222,118.416681:32.241933,118.415511:32.241298,118.415683:32.23814,118.416037:32.235644,118.416065:32.235439,118.414198:32.233034,118.415142:32.23092,118.420174:32.229967,118.423049:32.227943,118.424433:32.223432,118.428768:32.219057,118.429122:32.215381,118.430838:32.212894,118.43469:32.210933,118.440505:32.210252,118.444732:32.204315,118.446545:32.204515,118.449099:32.208255,118.450504:32.208872,118.456823:32.206766,118.457821:32.206857,118.458808:32.210407,118.460246:32.211332,118.463347:32.210243,118.463904:32.208001,118.461297:32.205232,118.460439:32.203834,118.462027:32.202618,118.463776:32.202318,118.466715:32.204379,118.468539:32.205296,118.470621:32.20535,118.472434:32.203144,118.472509:32.200048,118.474269:32.19875,118.489355:32.198384,118.496683:32.196731,118.508606:32.195096,118.517704:32.189321,118.522553:32.188195,118.526158:32.189902,118.529978:32.194714,118.532338:32.196131,118.539462:32.192408,118.548324:32.195096,118.548903:32.198273,118.550899:32.200144,118.556371:32.198419,118.561327:32.196821,118.566563:32.199835,118.562829:32.202885,118.569567:32.20343,118.572314:32.206843,118.57785:32.204519,118.576605:32.20245,118.579051:32.199327,118.584802:32.198818,118.588858:32.200298,118.585789:32.200507,118.583322:32.201578,118.568001:32.218118,118.558173:32.216883,118.550105:32.221712,118.540192:32.226722,118.530793:32.229772,118.494401:32.247776,118.480357:32.259014,118.462703:32.267827,118.455235:32.268226,118.449914:32.26692,118.441867:32.265668,118.425624:32.263636,118.424487:32.264861,118.424117:32.264995",
                    gridColour: "1EF705",
                    orgName: "三城镇",
                },
            ]
            arr.forEach((item) => {
                let polygonArr = []
                if (item.pointPosition) {
                    item.pointPosition.split(",").forEach((e) => {
                        polygonArr.push(e.split(":"))
                    })
                    var polygon = new AMap.Polygon({
                        map: this.map,
                        path: polygonArr, //设置多边形边界路径
                        strokeColor: "#" + item.gridColour, //线颜色
                        strokeOpacity: 0.2, //线透明度
                        strokeWeight: 3, //线宽
                        fillColor: "#" + item.gridColour, //填充色
                        fillOpacity: 0.35, //填充透明度
                        extData: {
                            name: item.orgName,
                        },
                    })
                    this.text3 = new AMap.Text({
                        text: item.orgName,
                        anchor: "center", //  设置文本标记锚点
                        draggable: true,
                        cursor: "pointer",
                        angle: 10,
                        style: {
                            "text-align": "center",
                            "font-size": "15px",
                            "background-color": "transparent",
                            color: "#fff",
                            "border-width": 0,
                        },
                        position: this.getCenterPoint(polygonArr),
                    })
                    this.text3.setMap(this.map)
                }
            })
        },
        getCenterPoint(data) {
            var lng = 0.0,
                lat = 0.0
            for (var i = 0; i < data.length; i++) {
                // if ($.isEmptyObject(data[i])) {
                // continue;
                // }
                lng = lng + parseFloat(data[i]["lng"])
                lat = lat + parseFloat(data[i]["lat"])
            }
            lng = lng / data.length
            lat = lat / data.length
            return [lng, lat]
        },
        drawArea() {
            for (let i = 0; i < this.areaList.length; i++) {
                // console.log(this.areaList,'2222')
                this.getArea(this.areaList[i].adcode, this.areaList[i].color)
            }
        },
        getArea(name, color) {
            // console.log(name, color)
            const self = this
            var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
            }
            let district = new AMap.DistrictSearch(opts)

            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker()
            district.search(name, (status, result) => {
                if (status == "complete") {
                    let bounds = result.districtList[0].boundaries
                    self.polygons = []
                    for (var i = 0, l = bounds.length; i < l; i++) {
                        self.polygon = new AMap.Polygon({
                            map: self.map,
                            strokeWeight: 1,
                            strokeColor: "#007CDB",
                            fillColor: color,
                            fillOpacity: 0.06,
                            path: bounds[i],
                        })
                        self.polygons.push(self.polygon)
                    }
                    // self.map.setFitView() //地图自适应
                }
            })
        },
        renderMapMarker(data) {
            let self = this
            if (data.length) {
                var endIcon = new AMap.Icon({
                    size: new AMap.Size(49, 56),
                    image: this.image,
                    imageSize: new AMap.Size(38, 42),
                })
                data.forEach((item) => {
                    console.log(item.longitude, item.latitude)
                    let marker = new AMap.Marker({
                        position: [
                            String(item.longitude),
                            String(item.latitude),
                        ],
                        icon: endIcon,
                    })
                    self.markers.push(marker)
                    // marker.on("mouseover", (e) => {})
                    // marker.on("click", (e) => {})
                })
            }
            self.map.add(self.markers)
            // self.map.setFitView(self.markers)
            self.map.setCenter([118.84315, 32.458977])
        },
        renderMapMarkers(data, type) {
            let self = this
            if (data.length) {
                var endIcon = new AMap.Icon({
                    size: new AMap.Size(49, 56),
                    image: this.image,
                    imageSize: new AMap.Size(38, 42),
                })
                data.forEach((item) => {
                    console.log(item.longitude, item.latitude)
                    let marker = new AMap.Marker({
                        position: [
                            String(item.longitude),
                            String(item.latitude),
                        ],
                        icon: endIcon,
                    })
                    self.markerss.push(marker)
                    // marker.on("mouseover", (e) => {})
                    marker.on("click", (e) => {
                        if (type == 1) {
                            this.showInfoPer1 = true
                            // alert(item.name)
                            this.peopleInfo = item
                        } else if (type == 2) {
                            this.showInfoPer2 = true
                            this.peopleInfo = item
                        } else if (type == 3) {
                            this.showInfoPer3 = true
                            this.peopleInfo = item
                        } else if (type == 4) {
                            this.showInfoPer4 = true
                            this.peopleInfo = item
                        }
                    })
                })
            }
            self.map.add(self.markerss)
            self.map.setZoom(10.5)
            self.map.setCenter([118.84315, 32.458977])
        },
        gethelpPeople(val) {
            this.$http
                .request({
                    url: "ypt/admin/laian/customer/info/findList",
                    method: "POST",
                    data: {
                        customerFlag: val,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.map.remove(this.markerss)
                            this.markerss = []
                            this.peopleLists = []
                            res.content.list.forEach((item) => {
                                if (
                                    item.id &&
                                    item.longitude &&
                                    item.latitude
                                ) {
                                    this.peopleLists.push({
                                        id: item.id,
                                        name: item.customerName,
                                        age: item.age,
                                        longitude: item.longitude,
                                        latitude: item.latitude,
                                        phone: item.familyPhone,
                                        sex: item.gender,
                                        censusRegister: item.address,
                                    })
                                }
                            })
                            if (val == 1) {
                                this.image = require("./assets/big/kun.png")
                                this.renderMapMarkers(this.peopleLists, 2)
                            } else if (val == 2) {
                                this.image = require("./assets/big/di.png")
                                this.renderMapMarkers(this.peopleLists, 3)
                            } else if (val == 3) {
                                this.image = require("./assets/big/can.png")
                                this.renderMapMarkers(this.peopleLists, 4)
                            }
                        }
                    }
                })
        },
    },
}
</script>

<style lang="less" scoped>
#container {
    position: absolute;
    left: 0;
    right: 0;
    top: 100px;
    bottom: 0;
    z-index: 1;
}
::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}
.tableBox /deep/ .el-table--fit {
    // padding: 20px;
    // background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table,
.el-table__expanded-cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}

.tableBox /deep/ .el-table tr .is-center {
    background-color: #01117b !important;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.close-info {
    color: #22f7ff;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 30px;
    cursor: pointer;
}
.perInfoBox {
    background: rgba(7, 17, 27, 0.5);
    position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    z-index: 9999;
}
.info-txt {
    position: relative;
    color: #fff;
    width: 50%;
    font-size: 14px;
    height: 28vh;
    overflow: scroll;
    margin: 10px auto;
    margin-top: 18%;
    background: #002673;
}
.intitle {
    color: #22f7ff;
    font-size: 18px;
}

.info-item {
    border-bottom: 1px solid #085e98;
    padding: 10px 30px;
    line-height: 40px;
}
.info-item:first-child {
    line-height: 25px !important;
    padding: 20px 30px;
}
.area {
    display: flex;
    color: #fff;
    position: relative;
    right: 175px;
    top: 60px;
}
.area > div {
    cursor: pointer;
    font-size: 13px;
    padding: 10px 20px;
    background: rgba(26, 70, 247, 0.4);
    color: #eee;
    margin: 0 10px;
    border-radius: 2px;
}
.aactive {
    background: #1a46f7 !important;
}
.top-menu {
    color: #fff;
    font-size: 13px;
    height: 80px;
    z-index: 99;
    position: absolute;
    top: 20px;
    width: 100%;
    justify-content: space-around;
}
.top-menu > div {
    background: rgba(1, 21, 141, 0.6);
    border: 1px solid rgba(34, 236, 255, 1);
}
.top-menu > div p {
    margin: 12px 0;
}
.l1 {
    background: rgba(26, 70, 247, 0.77);
}
.l1,
.l2,
.l3 {
    width: 20%;
    align-items: center;
    width: 20%;
    justify-content: space-around;
}
.l2,
.l3 {
    text-align: center !important;
}
.l1 > div {
    text-align: right;
}
p > img {
    width: 20px;
    margin-right: 10px;
}
.nums {
    font-size: 20px;
    color: #ffa200;
    font-weight: bold;
}
.color-l {
    color: #2372be;
}
.color-z {
    color: #f21b62;
}
.color-h {
    color: #ffa200;
}
.color-q {
    color: #a5fb52;
}
.color-g {
    color: #22f7ff;
}
.flex-item {
    display: flex;
}
.log-Main {
    background: url("./assets/big/data_bg.png") repeat;
    overflow-x: hidden;
    width: 100%;
}
.realTop {
    position: absolute;
    top: 0px;
    z-index: 2;
    background: url("./assets/big/oldTitle1.png");
    background-size: cover;
    margin: 0 auto;
    height: 90px;
    width: 100%;
}
.oldBox {
    border: 1px solid rgba(34, 236, 255, 1);
    background: #01117b;
    margin-top: 28px;
    position: relative;
    min-height: 35px;
    .leftTitle {
        position: absolute;
        width: 100%;
        height: 35px;
        background: url("./assets/big/titleLeft.png") no-repeat center;
        text-align: center;
        font-size: 17px;
        line-height: 35px;
        color: #22f7ff;
        top: -17px;
    }
}

#pieChart {
    width: 350px;
    height: 300px;
}
.party-map {
    width: 100%;
    /* height: calc(100vh - 20px); */
    height: 100vh;
}
.colorOrange {
    color: #ffa200;
}
.colorPink {
    color: #d800ff;
}
.colorCycan {
    color: #a5fb52;
}
.colorRed {
    color: #f21b62;
}
.colorBlue {
    color: #22f7ff;
}
.oldLeft {
    position: absolute;
    top: 100px;
    left: 20px;
    width: 990px;
    height: 116px;
    background: rgba(1, 21, 141, 0.6);
    border: 1px solid rgba(34, 236, 255, 1);
    .oldLeftBox {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 116px;
        .oldLeftItem {
            text-align: center;
            flex: 1;
            .name {
                color: #fff;
                font-size: 18px;
                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 5px;
                }
            }
            .num {
                color: #ffa200;
                margin-top: 10px;
                font-size: 34px;
                margin-left: 30px;
            }
        }
    }
}
.oldRight {
    z-index: 1000;
    position: absolute;
    top: 120px;
    right: 20px;
    width: 850px;
    .rightNumBox {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 114px;
        text-align: center;
        .rightNumBoxItem {
            margin-right: 12px;
            height: 112px;
            background: rgba(1, 21, 141, 0.6);
            border: 1px solid rgba(34, 236, 255, 1);
            flex: 1;
            .name {
                font-size: 26px;
                padding-top: 20px;
            }
            .num {
                padding-top: 7px;
                color: #22f7ff;
                font-size: 15px;
            }
        }
        .rightNumBoxItem3 {
            flex: 3;
            display: flex;
            align-items: center;
            height: 112px;
            justify-content: center;
            background: rgba(1, 21, 141, 0.6);
            border: 1px solid rgba(34, 236, 255, 1);
            .item3It {
                flex: 1;
                .name {
                    color: #f5f5f5;
                    font-size: 18px;
                }
                .num {
                    font-weight: bold;
                    font-size: 28px;
                }
            }
        }
    }
}
#oldNums {
    width: 100%;
    height: 40vh;
}
.percentBox {
    padding-top: 20px;
    display: flex;
    .percentItem {
        flex: 1;
        .percentTitle {
            color: #00d2ff;
            font-size: 16px;
            padding: 10px 0 0 30px;
        }
        #sexPercent {
            width: 100%;
            height: 22vh;
        }
        #agePercent {
            width: 100%;
            height: 22vh;
        }
        #healthPercent {
            width: 100%;
            height: 22vh;
        }
        .mallNote {
            margin: -60px 0 0 15px;
            padding-bottom: 20px;
            font-size: 12px;
            ul {
                display: flex;
                li {
                    flex: 1;
                    padding: 5px 0;
                }
            }
            .sexInfos {
                padding-left: 30px;
            }
            .icon {
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
            }
            .icon1 {
                background: #0f5bf5;
            }
            .icon2 {
                background: #73c0de;
            }
            .icon3 {
                background: #7fd42d;
            }
            .icon4 {
                background: #f21b62;
            }
            .icon5 {
                background: #ffb026;
            }
            .num,
            .name {
                display: inline-block;
                text-align: right;
                color: #22f7ff;
                margin: 0 10px 0 8px;
            }
            .name1 {
                width: 30px !important;
            }
            .ml25 {
                margin-left: 25px;
            }
            .num {
                width: 40px;
            }
        }
    }
}

.newDiv {
    position: absolute;
    background: red;
    color: white;
    width: 100px;
    height: 50px;
}
.mapOpen {
    display: flex;
    width: 700px;
    .mapImg {
        width: 180px;
        height: 180px;
        margin-right: 12px;
    }
    .mapFlex {
        flex: 1;
        color: #474747;
        font-size: 30px;
        .address,
        .info {
            padding-top: 12px;
        }
    }
}
.quanp {
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 100;
    button {
        padding: 10px;
    }
}
.modelfy {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-size: 100% 100%;
}
.shubaio :hover {
    cursor: pointer;
}
#box {
    width: 100px;
    height: 100px;
    background-color: coral;
    /*保证div能移动，一定要添加定位*/
    position: absolute;
    cursor: move;
    top: 242;
    left: 394;
}
.activeList2 {
    color: #fff;
    flex: 1;
    text-align: center;
    font-size: 14px;
    height: 199px;
    overflow: scroll;
}
.ac-item {
    padding: 15px 10px;
    border-bottom: 1px solid #0f5bf5;
    font-size: 13px;
    cursor: pointer;
}
.ac-title2 {
    color: #1a46f7;
    font-size: 16px;
    border-bottom: 2px solid #0f5bf5;
    position: relative;
    z-index: 99;
    background: #01117b;
}
</style>
<style lang="less">
.amap-marker {
    transform: rotate(0deg) !important;
}
</style>

